export default __webpack_public_path__ + "static/media/5.6042e8b2.png";